<template>

  <modal name="editProjectModal" @closed="hideModal" tabindex="-1" aria-hidden="true" width="700" height="auto" style="overflow-y: scroll;">
    <div class="row p-4" v-if="project && project.members">

      <div class="col-md-12">
        <button @click="hideModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            &times;
          </span>
        </button>

        <ul class="nav mt-4 nav-tabs nav-tabs-sm">
          <li class="nav-item">
            <a @click="show_tab='overview'" :class="{'active': show_tab==='overview'}" href="#" class="nav-link">
              <i class="fe fe-briefcase mr-2"></i>{{ $t('modals.edit_project_modal.overview') }}
            </a>
          </li>
          <li class="nav-item">
            <a @click="show_tab='members'" :class="{'active': show_tab==='members'}" href="#" class="nav-link">
              <i class="fe fe-users mr-2"></i>{{ $t('modals.edit_project_modal.members') }}
            </a>
          </li>
          <li class="nav-item">
            <a @click="show_tab='sections'" :class="{'active': show_tab==='sections'}" href="#" class="nav-link">
              <i class="fe fe-folder mr-2"></i>{{ $t('modals.edit_project_modal.sections') }}
            </a>
          </li>
          <li class="nav-item">
            <a @click="show_tab='epic_links'" :class="{'active': show_tab==='epic_links'}" href="#" class="nav-link">
              <i class="fe fe-bookmark mr-2"></i>{{ $t('modals.edit_project_modal.epic_links') }}
            </a>
          </li>
        </ul>
        <div v-if="show_tab === 'overview'">
          <div class="row">
            <div class="col-6">
              <label class="mb-1 mt-4" style="color: black">{{ $t('modals.edit_project_modal.project_name') }}</label>
              <input spellcheck="false" placeholder="Set project name" rows="1"
                     class="form-control form-control-sm textInput" v-model="project.name" style="font-weight: bold">

              <label class="mb-1 mt-4">{{ $t('modals.edit_project_modal.project_description') }}</label>
              <input spellcheck="false" placeholder="" rows="1" class="form-control form-control-sm textInput"
                     v-model="project.description" style="font-size: 1em">

            </div>
            <div class="col-6 p-0">
              <label class="mb-1 mt-4">{{ $t('modals.edit_project_modal.project_color') }}</label>
              <div class="row">
                <div class="col-1">
                  <svg style="display: block; margin: auto" width="29" height="29" viewBox="0 0 29 29" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <rect width="29" height="29" rx="16" :fill="`url(#paint_color_${actualProjectColors[0]}`"/>
                    <defs>
                      <linearGradient :id="`paint_color_${actualProjectColors[0]}`" x1="10" y1="0" x2="10" y2="20"
                                      gradientUnits="userSpaceOnUse">
                        <stop :stop-color="`#${actualProjectColors[0]}`"/>
                        <stop :offset="1" :stop-color="`#${actualProjectColors[1]}`"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div
                  @click="show_project_select_color_editor = !show_project_select_color_editor"
                  class="col-9 ml-2 unselectable"
                  style="padding-top: 5px; cursor: pointer">
                  <span style="color: black; font-size: 0.8em; font-weight: bold">{{ $t('modals.edit_project_modal.change_color') }}</span>
                </div>
                <edit-project-select-color
                  @newColor="updateColor"
                  v-if="show_project_select_color_editor"
                  :project="project"
                  class="col-8"></edit-project-select-color>
              </div>
            </div>
          </div>
          <!--<div class="row mt-4">
            <div class="col-6">
              <label class="mb-1 mt-4" style="color: black">{{ $t('modals.edit_project_modal.default_tasks.assignee') }}</label>
              <person-select
                @selectUser="setDefaultAssignee"
                ref="addPersonSelect"
                view="project"
                :exclude_emika="true"
                :show_all_projects="false"
                :projectSettings="true"
                :projectAssignee="project.default_assignee"></person-select>
            </div>
            <div class="col-6">
              <label class="mb-1 mt-4" style="color: black">{{ $t('modals.edit_project_modal.default_tasks.priority') }}</label>
              <priority-select :project="project" @newPriority="updatePriority" :isDefaultProjectPriority="true"></priority-select>
            </div>
            &lt;!&ndash;<div class="col-6">
              <label class="mb-1 mt-4" style="color: black">{{ $t('modals.edit_project_modal.default_tasks.epic_links') }}</label>
&lt;!&ndash;                    <epic-links-select></epic-links-select>&ndash;&gt;
            </div>
            <div class="col-6">
              <label class="mb-1 mt-4" style="color: black">{{ $t('modals.edit_project_modal.default_tasks.deadline') }}</label>
&lt;!&ndash;                    <date-select></date-select>&ndash;&gt;
            </div>&ndash;&gt;
          </div>-->
          <!--<div class="row mt-4">
            <div class="col-6">
              <label class="mb-1 mt-4" style="color: black">{{ $t('modals.edit_project_modal.default_tasks.duration') }}</label>
              <duration-picker class="mt-2" @selectDuration="updateDuration" :task_mode="false" :is_for_project="true" :project="project"></duration-picker>
            </div>
          </div>-->
          <div class="mt-6">
            <button
              v-if="company.managers && company.managers.indexOf(account._id) > -1"
              v-on:click="archiveProject"
              type="button"
              class="btn btn-sm btn-light float-left">
              <i class="fe fe-archive"></i>
              {{ $t('modals.edit_project_modal.archive_project') }}
            </button>
            <button v-on:click="saveChanges" type="button" class="btn btn-sm btn-primary float-right"><i
              class="fe fe-check-circle mr-2"></i>
              {{ $t('modals.edit_project_modal.save_changes') }}
            </button>
          </div>
        </div>
        <div v-if="show_tab==='members'">
          <div v-if="project.is_personal" class="card dash-section text-center p-3 w-50">
            <p class="text-muted">{{ $t('modals.edit_project_modal.unable_to_add_members_to_personal_projects') }}</p>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-6 mb-1 mt-4">
                <label><i class="fe fe-user-plus mr-2"></i>{{ $t('modals.edit_project_modal.add_members_within_company')
                  }}</label>
              </div>
              <div class="col-6 mb-1 mt-4">
                <a href='/company' class="btn btn-sm btn-link float-right">{{
                  $t('modals.edit_project_modal.invite_people') }}<i class="fe ml-1 fe-chevron-right"></i></a>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card shadow-sm p-3">
                  <div class="row">
                    <div class="col-5">
                      <person-select ref="addPersonSelect" view="project" :exclude_emika="true"
                                     :exclude_list="project.members"></person-select>
                    </div>
                    <div class="col-2">
                      <button
                        :class="{disabled: project.members.indexOf(selected_account_id) >= 0}"
                        :disabled="project.members.indexOf(selected_account_id) >= 0"
                        @click="addMember()"
                        class="btn btn-outline-primary btn-sm active">
                        <i class="fe fe-plus mr-2"></i>
                        {{ $t('modals.edit_project_modal.add') }}
                      </button>
                    </div>
                    <div class="col-5">
                      <div class="custom-control custom-switch pl-0">
                        <div class="row">
                          <div class="col-9">
                            <span class="text-muted" style="font-size: 12px; line-height: 12px; vertical-align: top;">{{ $t('modals.edit_project_modal.automatically_add_new_employees') }}</span>
                          </div>
                          <div class="col-3 pl-5 pt-2">
                            <input
                              v-model="project.is_company_wide"
                              @change="saveChanges"
                              type="checkbox"
                              class="custom-control-input float-right"
                              id="setWide">
                            <label class="custom-control-label float-right" for="setWide"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="project.members && project.members.length > 0">
            <div class="row mt-4">
              <div class="col-md-12" v-for="member_id in project.members" :key="member_id">

                <div class="card p-2 shadow-sm ">
                  <div class="row">
                    <div class="col-md-1 d-flex justify-content-center">
                      <div class="avatar avatar avatar-disabled" style="width: 29px; height: 29px">
                        <div class="avatar avatar" style="width: 29px; height: 29px">
                          <img v-if="getMember(member_id).picture_url" :src="getMember(member_id).picture_url"
                               style="transition: 1s filter ease-out; vertical-align: auto" alt="..."
                               class="avatar-img rounded-circle shadow-sm">
                          <span v-else class="avatar-title mr-2 rounded-circle">{{(getMember(member_id).first_name || '').slice(0, 1)+(getMember(member_id).last_name || '').slice(0, 1)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <b class="middle">{{getMember(member_id).first_name}} {{getMember(member_id).last_name}} </b>
                      <span v-if="getMember(member_id).first_name==='Georgii'" class="badge badge-soft-light">Dep. Manager</span>
                    </div>
                    <div class="col-md-3">
                      <div class="text-muted small middle">{{getMember(member_id).job_title}}</div>
                    </div>
                    <template
                      v-if="(company.managers && company.managers.indexOf(account._id) > -1) || project.managers && project.managers.indexOf(account._id) > -1">
                      <div class="col-md-3 text-center">
                        <button v-if="project.managers && project.managers.indexOf(member_id) > -1"
                                @click="toggleManager(true, member_id)" class="btn btn-outline-primary btn-sm active ">
                          Manager
                        </button>
                        <a v-else href="#" @click="toggleManager(false, member_id)"
                           class="btn btn-sm btn-link middle mt-1">Set as manager</a>
                      </div>
                      <div class="col-md-1">
                        <button v-if="!project.is_personal && project.members.length > 1"
                                @click="deleteMember(member_id)" class="btn btn-sm float-right btn-outline-danger"><i
                          class="fe fe-user-minus"></i></button>
                      </div>
                    </template>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div v-if="show_tab==='sections'">
          <div class="row">
            <div class="col-md-7 ">
              <label class="mb-1 mt-4"><i class="fe fe-folder-plus mr-2"></i>{{
                $t('modals.edit_project_modal.add_section') }}</label>
              <div class="card p-3 mb-0">
                <div class="row">
                  <div class="col-9">
                    <input v-model="new_section.name" class="form-control form-control-sm"
                           placeholder="Set section name">
                  </div>
                  <div class="col-3">
                    <button @click="createSection" class="btn btn-outline-primary btn-sm active"><i
                      class="fe fe-plus mr-2"></i>{{ $t('modals.edit_project_modal.add') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <draggable
                class="list-group"
                tag="ul"
                v-model="sections_list"
                v-bind="dragOptions"
                @change="updateSections"
                @start="drag = true"
                @end="drag = false"
              >
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                  <div
                    class="mt-4"
                    :style="{'cursor': drag ? 'grabbing' : 'grab'}"
                    v-for="section in sections_list"
                    :key="section._id"
                  >
                    <div class="card p-3 shadow-sm ">
                      <div class="row ">
                        <div class="col-md-10" v-if="edit_section_id === section._id">
                          <input v-model="section.name" class="form-control form-control-sm"
                                 placeholder="Set section name">
                        </div>
                        <div class="col-md-8 " v-else>
                          <h3 class="font-weight-light mb-0 middle">{{section.name}}</h3>
                        </div>
                        <div class="col-md-2" v-if="edit_section_id === section._id">
                          <button @click="updateSection(section)" class="btn btn-sm btn-primary float-right"><i
                            class="fe fe-check-circle"></i></button>
                        </div>
                        <div v-else class="col-md-4">
                          <button @click="deleteSection(section._id)"
                                  class="btn btn-sm btn-outline-danger float-right ml-3"><i class="fe fe-trash-2"></i>
                          </button>
                          <button @click="edit_section_id = section._id" class="btn btn-sm btn-light float-right ml-3">
                            <i class="fe fe-edit-3"></i></button>
                          <button v-if="project.default_section_id === section._id"
                                  class="btn btn-sm btn-outline-primary float-right active" style="cursor: default">{{
                            $t('modals.edit_project_modal.default') }}
                          </button>
                          <button v-else @click="project.default_section_id = section._id"
                                  class="btn btn-sm btn-outline-primary float-right">{{
                            $t('modals.edit_project_modal.set_as_default') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
        <div v-if="show_tab==='epic_links'">
          <div class="row ">
            <div class="col-md-7">
              <label class="mb-1 mt-4">
                <svg class="mb-1" width="8" height="10" viewBox="0 0 8 10" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 2.5V5.5" stroke="#13273E" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2.5 4H5.5" stroke="#13273E" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                    d="M7.49976 9.5L3.99976 7L0.499756 9.5V1.5C0.499756 1.23478 0.605113 0.98043 0.792649 0.792893C0.980185 0.605357 1.23454 0.5 1.49976 0.5H6.49976C6.76497 0.5 7.01933 0.605357 7.20686 0.792893C7.3944 0.98043 7.49976 1.23478 7.49976 1.5V9.5Z"
                    stroke="#13273E" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                {{ $t('modals.edit_project_modal.add_epic_links') }}
              </label>
              <div class="card p-3">
                <div class="row">
                  <div class="col-9">
                    <input v-model="new_epic_link.name" class="form-control form-control-sm"
                           placeholder="Set epic link name">
                  </div>
                  <div class="col-3">
                    <button @click="createEpicLink" class="btn btn-outline-primary btn-sm active"><i
                      class="fe fe-plus mr-2"></i>{{ $t('modals.edit_project_modal.add') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <draggable
                class="list-group"
                tag="ul"
                v-model="epic_links_list"
                v-bind="dragOptions"
                @change="updateEpicLinks"
                @start="drag = true"
                @end="drag = false"
              >
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                  <div
                    class="mt-4"
                    :style="{'cursor': drag ? 'grabbing' : 'grab'}"
                    v-for="epic_link in epic_links_list"
                    :key="epic_link._id"
                  >
                    <div class="card p-3 shadow-sm ">
                      <div class="row">
                        <div class="col-md-10" v-if="edit_epic_link_id === epic_link._id">
                          <input v-model="epic_link.name" class="form-control form-control-sm"
                                 placeholder="Set epic link name">
                        </div>
                        <div class="col-md-8" v-else>
                          <h3 class="font-weight-light mt-2">{{epic_link.name}}</h3>
                        </div>
                        <div class="col-md-2" v-if="edit_epic_link_id === epic_link._id">
                          <button @click="updateEpicLink(epic_link)" class="btn btn-sm btn-primary float-right"><i
                            class="fe fe-check-circle"></i></button>
                        </div>
                        <div v-else class="col-md-4">
                          <button @click="deleteEpicLink(epic_link._id)"
                                  class="btn btn-sm btn-outline-danger float-right ml-2"><i class="fe fe-trash-2"></i>
                          </button>
                          <button @click="edit_epic_link_id = epic_link._id" class="btn btn-sm btn-light float-right"><i
                            class="fe fe-edit-3"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import draggable from 'vuedraggable';
  import PersonSelect from '../components/elements/PersonSelect';
  // import DurationPicker from '../elements/DurationPicker';
  // import PrioritySelect from '../elements/PrioritySelect';
  // import DateSelect from '../elements/DateSelect';
  // import EpicLinksSelect from '../elements/EpicLinksSelect';
  import EditProjectSelectColor from '../components/elements/EditProjectSelectColor';
  import projectColors from '../configs/projectColors';

  export default {
    name: 'edit_project',
    data () {
      return {
        show_project_select_color_editor: false,

        show_tab: 'members',
        drag: false,
        project: null,
        epic_links_list: [],
        sections_list: [
          { name: 'Todo 1', autocomplete: true, _id: '1' },
          { name: 'In Progress 2', autocomplete: false, _id: '2' },
          { name: 'Complete 3', autocomplete: false, _id: '3' },
        ],
        new_epic_link: {
          name: '',
          project_id: '',
        },
        edit_epic_link_id: null,
        new_section: {
          name: '',
          project_id: '',
        },
        edit_section_id: null,
      };
    },
    computed: {
      ...mapGetters([
        'account',
        'dragOptions',
        'projects',
        'members',
        'company',
        'selected_project_id',
        'selected_account_id',
        'show_modal_edit_project',
        'sections',
        'epic_links',
      ]),
      actualProjectColors: function () {
        if (!this.project.color) {
          this.$set(this.project, 'color', 0);
        }
        return projectColors[this.project.color] ? projectColors[this.project.color] : ['D62121', 'FB6B6B'];
      },
    },
    watch: {
      show_modal_edit_project: function () {
        const self = this;
        if (self.show_modal_edit_project === true) {
          this.$modal.show('editProjectModal');
          self.show_tab = 'members';
          self.calculateProjectInfo();
        }
      },
      selected_project_id: function () {
        this.project = Object.assign({}, this.projects.find(p => p._id === this.selected_project_id, 1));
      },
    },

    methods: {
      getMember (memberId) {
        return this.members.find(m => m._id === memberId, 1) || {};
      },
      adjustTextArea (event) {
        event.target.style.height = ''; /* Reset the height */
        event.target.style.height = Math.min(event.target.scrollHeight, 150) + 'px';
      },
      archiveProject () {
        this.project.status = 'deleted';
        this.saveChanges();
      },
      discardChanges () {

      },
      addMember () {
        if (!(this.project.members.indexOf(this.selected_account_id) >= 0)) {
          this.project.members.push(this.selected_account_id);
          this.saveChanges();
        } else {
          this.$noty.show('This member is already within the project');
        }
      },
      toggleManager (isManager, personId) {
        if (isManager) {
          this.project.managers.length > 1
            ? this.project.managers = this.project.managers.filter(m => m !== personId)
            : this.$noty.show('Unable to dismiss the last manager of company');
        } else {
          this.project.managers.indexOf(personId) === -1
            ? this.project.managers.push(personId)
            : this.$noty.show('This member is already a manager');
        }
        this.saveChanges();
      },
      deleteMember (personId) {
        if (this.project.members.length > 1) {
          this.project.members = this.project.members.filter(id => id !== personId);
          this.saveChanges();
        } else {
          this.$noty.show('Unable to dismiss the last member of the project');
        }
      },
      saveChanges () {
        this.$store.dispatch('updateProject', this.project);
        this.$noty.success('Project changes were saved successfully');
      },
      calculateProjectInfo () {
        this.project = Object.assign({}, this.projects.find(p => p._id === this.selected_project_id, 1));
        this.epic_links_list = this.epic_links.filter(epicLink => epicLink.project_id === this.project._id);
        this.sections_list = this.sections.filter(section => section.project_id === this.project._id);
      },

      updateDuration (time) {
        this.project.default_duration = time;
      },
      updateColor (color) {
        this.project.color = color;
      },
      setDefaultAssignee (user) {
        this.project.default_assignee = user;
      },
      updatePriority (priority) {
        this.project.default_priority = priority;
      },
      updateEpicLinks () {
        this.$store.dispatch('updateEpicLinksOrder', this.epic_links_list);
      },
      createEpicLink () {
        if (this.new_epic_link.name.length > 2) {
          if (this.epic_links_list.find(epicLink => epicLink.name === this.new_epic_link.name)) {
            this.$noty.show("Epic link with such name already exists. Let's create a unique name for that one.");
          } else {
            this.new_epic_link.project_id = this.project._id;
            this.$store.dispatch('createEpicLink', this.new_epic_link);
            this.$noty.success('Epic link created successfully');

            setTimeout(() => this.calculateProjectInfo(), 1700);
            this.new_epic_link.name = '';
          }
        } else {
          this.$noty.show('Epic link name should be 3 characters or longer');
        }
      },
      updateEpicLink (epicLink) {
        if (epicLink.name.length > 2) {
          epicLink.project_id = this.project._id;
          this.$store.dispatch('updateEpicLink', epicLink);
          this.$noty.success('Epic link updated successfully');
          this.edit_epic_link_id = null;
          setTimeout(() => this.calculateProjectInfo(), 1700);
        } else {
          this.$noty.show('Epic link name should be 3 characters or longer');
        }
      },
      deleteEpicLink (epicLinkId) {
        this.$store.dispatch('deleteEpicLink', epicLinkId);
        this.$noty.success('Epic link was deleted successfully');
        this.edit_epic_link_id = null;
        this.epic_links_list.splice(this.epic_links_list.findIndex(epicLink => epicLink._id === epicLinkId), 1);
        setTimeout(() => this.calculateProjectInfo(), 1700);
      },

      updateSections () {
        this.$store.dispatch('updateSectionsOrder', this.sections_list);
      },
      createSection () {
        if (this.new_section.name.length > 2) {
          if (this.sections_list.find(section => section.name === this.new_section.name)) {
            this.$noty.show("Section with such name already exists. Let's create a unique name for that one.");
          } else {
            this.new_section.project_id = this.project._id;
            this.$store.dispatch('createSection', this.new_section);
            this.$noty.success('Section created successfully');

            setTimeout(() => this.calculateProjectInfo(), 1700);
            this.new_section.name = '';
          }
        } else {
          this.$noty.show('Section name should be 3 characters or longer');
        }
      },
      updateSection (section) {
        if (section.name.length > 2) {
          section.project_id = this.project._id;
          this.$store.dispatch('updateSection', section);
          this.$noty.success('Section updated successfully');
          this.edit_section_id = null;
          setTimeout(() => this.calculateProjectInfo(), 1700);
        } else {
          this.$noty.show('Section name should be 3 characters or longer');
        }
      },
      deleteSection (sectionId) {
        if (this.sections_list.length > 1) {
          this.$store.dispatch('deleteSection', sectionId);
          this.$noty.success('Section was deleted successfully');
          this.edit_section_id = null;
          this.sections_list.splice(this.sections_list.findIndex(section => section._id === sectionId), 1);
          setTimeout(() => this.calculateProjectInfo(), 1700);
        } else {
          this.$noty.show('Sorry but you can not delete the last section');
        }
      },
      hideModal () {
        this.$store.commit('hideModal', 'edit_project');
        this.$modal.hide('editProjectModal');
      },
    },
    components: {
      EditProjectSelectColor,
      PersonSelect,
      // EpicLinksSelect,
      // DurationPicker,
      // PrioritySelect,
      // DateSelect,
      draggable,
    },

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  html, body {
    width: 100%;
    height: 100%;
  }

  label {
    color: black;
  }

  .textInput {
    border-width: 0 0 1px 0;
    border-radius: 0;
    font-size: 1.2rem;
    resize: none;
    text-shadow: 0 0.2px gainsboro;
    padding: 0;
    line-height: 0 !important;
    height: auto;
  }

  .middle {
    display: inline-block;
    vertical-align: bottom;
    line-height: 16px;
  }

  .btn-outline-primary:focus {
    box-shadow: 0 0 0 0 !important;
  }
</style>
